import { cva } from 'class-variance-authority';

/**
 * Progress class recipes. Slots live on `.ds-progress` in `design-system.css`, so there is no
 * `dark:` variant here.
 *
 * Ported from Figma `Progress`, page `Progress [In progress]`, read 2026-09-25: Size (Medium 8 /
 * Small 4) x Tone (Accent / Success) x Value (0 / 25 / 50 / 75 / 100). Value is a variant only
 * because Figma cannot take a number; code takes any value.
 */
export const progressRootRecipe = cva(['ds-progress', 'block w-full min-w-0']);

/** Fully rounded, and clipping, so the fill's own rounded end is what shows at every value. */
export const progressTrackRecipe = cva(
  ['relative block w-full overflow-hidden rounded-full bg-[var(--ds-progress-track)]'],
  {
    variants: {
      size: { md: 'h-[8px]', sm: 'h-[4px]' },
    },
    defaultVariants: { size: 'md' },
  }
);

/**
 * The fill is always full width and slides in from the left, so a change of value is a
 * `translate` — never a `width`, which would re-layout on every tick of an upload. `--motion-layout`
 * because the bar is an element changing size on screen, not a control changing state; under
 * reduced motion it jumps.
 *
 * `--ds-progress-value` is written inline by the component, as a percentage.
 */
export const progressFillRecipe = cva(
  [
    'absolute inset-0 block rounded-full',
    'translate-x-[calc(var(--ds-progress-value)-100%)]',
    'transition-[translate] duration-[var(--motion-layout)] ease-[var(--motion-layout-ease)] motion-reduce:transition-none',
  ],
  {
    variants: {
      tone: {
        accent: 'bg-[var(--ds-progress-fill)]',
        success: 'bg-[var(--ds-progress-fill-success)]',
      },
    },
    defaultVariants: { tone: 'accent' },
  }
);
